import { WorkerState } from 'features/common/workerSlice';
import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';
import {
  CreateDeliveryInfo,
  DeliveryInfo,
  DeliveryMasterDataInfo,
  DeliverySearchPayload,
  DeliverySetting,
  TargetSchema,
  TestReflectionDelivery,
} from './models/delivery';
import { DeliveryDetailInfo } from './models/deliveryDetail';

const deliveryService = {
  getDeliveryMasterData(): Promise<CommonResponse<DeliveryMasterDataInfo>> {
    const url = `master-data?types=delivery_status,approval_status,sale_type,counter_pattern`;
    return axiosClient.get(url);
  },
  getDeliveryList(params: DeliverySearchPayload): Promise<CommonResponse<DeliveryInfo>> {
    const url = `deliveries`;
    return axiosClient.get(url, { params });
  },
  getDeliveryDetail(delivery_id: number): Promise<CommonResponse<DeliveryDetailInfo>> {
    const url = `delivery-details/${delivery_id}`;
    return axiosClient.get(url);
  },
  getTargetSchemaList(): Promise<CommonResponse<TargetSchema[]>> {
    const url = `target-schemas`;
    return axiosClient.get(url);
  },
  deliveryCheckError(data: DeliverySetting): Promise<CommonResponse<CreateDeliveryInfo>> {
    const url = `delivery/check-error`;
    return axiosClient.post(url, data);
  },
  createDelivery(data: DeliverySetting): Promise<CommonResponse<CreateDeliveryInfo>> {
    const url = `delivery`;
    return axiosClient.post(url, data);
  },
  createDeliveryAsync(data: DeliverySetting): Promise<CommonResponse<WorkerState>> {
    const url = `delivery/async`;
    return axiosClient.post(url, data);
  },
  getAsyncDeliveryCreateStatus(taskId: string): Promise<CommonResponse<WorkerState>> {
    const url = `delivery/async/status/${taskId}`;
    return axiosClient.get(url);
  },
  getWorkflowActions(delivery_id: number): Promise<CommonResponse<any>> {
    const url = `workflow-actions/${delivery_id}`;
    return axiosClient.get(url);
  },
  doWorkflowAction(delivery_id: number, action: string, employee_job_id: number): Promise<CommonResponse<any>> {
    const url = `workflow-action`;
    return axiosClient.post(url, { delivery_id, action, employee_job_id });
  },
  createTestReflectionDelivery(data: TestReflectionDelivery): Promise<CommonResponse<CreateDeliveryInfo>> {
    const url = `test-reflection-delivery`;
    return axiosClient.post(url, data);
  },
  checkSchemaAlreadyExists(
    deliveryId: number
  ): Promise<
    CommonResponse<{ delivery_id: number; schema_exists: boolean; schema_name: string; table_count: number }>
  > {
    const url = `schema-check`;
    return axiosClient.get(url, { params: { delivery_id: deliveryId } });
  },
  asyncRestoreSchema(deliveryId: number): Promise<CommonResponse<WorkerState>> {
    const url = `restore/async`;
    return axiosClient.post(url, { delivery_id: deliveryId });
  },
  getAsyncRestoreStatus(taskId: string): Promise<CommonResponse<WorkerState>> {
    const url = `restore/async/status/${taskId}`;
    return axiosClient.get(url);
  },
  getAsyncRestoreStatusByDelivery(deliveryId: number): Promise<CommonResponse<WorkerState>> {
    const url = `restore/async/status-by-delivery`;
    return axiosClient.get(url, { params: { delivery_id: deliveryId } });
  },
  checkDBVersion(deliveryId: number): Promise<CommonResponse<{ delivery_id: number; is_correct_db_version: boolean }>> {
    const url = `check-db-version`;
    return axiosClient.get(url, { params: { delivery_id: deliveryId } });
  },
};

export default deliveryService;
